import { toAbsoluteUrl } from 'app/infrastructure/hosting';

/**
 * Temporary icon support until database has the mapping
 */
export const tabIconForDomain = (id) => {

  const file = {
    [8500]: 'actions',
    [8778]: 'attachments',
    [340]: 'causes',
    [4089]: 'check-list',
    [8668]: 'comments',
    [11774]: 'connected-cases',
    [159]: 'general-classifications',
    [8660]: 'involved-drugs',    
    [124]: 'involved-persons',    
    [316]: 'loss-potential',    
    [8670]: 'signatures',    
    [172]: 'consequences',    
    [104]: 'where-and-what'
  }[id] || 'default';

  return toAbsoluteUrl(`i/case-sections/${file}.svg`);
};
